<template>
  <div>
  </div>
</template>

<script>
  import ApiClient from '@/utils/api-client'

  export default {
    data() {
      return {
        message: null
      }
    },
    beforeCreate() {
      const query = this.$route.query
      ApiClient.put('email-confirmation', {data:{email: query.email, token: query.token}})
        .then(() => {
          this.$router.push("/")
          this.$Message.info("Seu cadastro foi confirmado com sucesso")
        })
        .catch(() => {
          this.$router.push("/")
          this.message = "Houve um problema ao tentar confirmar seu e-mail"
        })
    },
    methods: {
      //tagueamento GA
      taggingGA() {
        this.$ga.page({
          page: '/confirmacao-email',
          title: 'EmailConfirmation',
        })
      },
    },

    async created() {
      //tagueamento GA
      await this.taggingGA();
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/EmailConfirmation.vue